module.exports = __webpack_public_path__ + "static/media/REPORT-COUNT-1.d1c71cd1.png";